<template>
    <modal name="balance-in" @before-open="beforeOpen" @before-close="beforeClose" :classes="[
        'v--modal',
        'modal',
        'error-modal',
        'balance-modal',
        'balance-in-modal',
        hasBugs && 'has-bugs',
    ]" :width="730" :height="'auto'" :scrollable="true" :adaptive="true">
        <div class="modal-title">{{ $t("balanceIn.balanceReplenishment") }}</div>
        <div class="modal-close" @click="close"></div>
        <div class="modal-body">
            <div class="modal-subtitle">
                {{ $t("balanceIn.selectNumberSprigs") }}:
            </div>
            <div v-if="pageLoader" class="balance-packages-list">
                <button class="button-loader"></button>
            </div>
            <ul v-else class="balance-packages-list">
                <li v-for="(paymentPackage, index) in packages" @click="currentPackage = paymentPackage.id"
                    class="balance-packages-item" :key="index" :class="{
                        'balance-packages-item-selected':
                            currentPackage == paymentPackage.id,
                    }">
                    <div>
                        <span class="balance-packages-text">
                            {{ paymentPackage.amount }}
                            {{
                                declineNouns(paymentPackage.amount, [
                                    $t("balanceIn.zarik"),
                                    $t("balanceIn.zarika"),
                                    $t("balanceIn.zarikov"),
                                ])
                            }}
                        </span>
                        <br />
                        <span class="balance-packages-price">
                            {{ paymentPackage.cost }}
                            {{
                                declineNouns(paymentPackage.cost, [
                                    $t("balanceIn.ruble"),
                                    $t("balanceIn.rublya"),
                                    $t("balanceIn.rubley"),
                                ])
                            }}
                        </span>
                    </div>
                </li>
            </ul>
            <!-- <div class="modal-subtitle">
                {{ $t("balanceIn.chooseHowWantRecharge") }}:
            </div>
            <ul class="balance-way-list">
                <li v-for="(way, index) in ways" @click="wayIndex = index + 1" class="balance-way-item" :key="index"
                    :class="{ 'balance-way-item-selected': wayIndex == index + 1 }">
                    <div class="balance-way-text">{{ way }}</div>
                </li>
            </ul> -->
            <div v-if="wayIndex == 2 || wayIndex == 3" class="balance-phone">
                <div class="modal-subtitle">{{ $t("balanceIn.enterPhoneNumber") }}</div>
                <input v-model="phone" v-validate.persist="{
                    required: true,
                    regex: /^\+[0-9]{11,}$/,
                    min: 11,
                }" name="phone" type="text" class="input" :class="{ 'field-error': errors.has('phone') }" />
                <div class="v-error">{{ errors.first("phone") }}</div>
            </div>
            <div class="buttons-row">
                <button @click="close" type="button" class="button-secondary">
                    {{ $t("balanceIn.cancel") }}
                </button>
                <button @click="send" v-if="!loader" class="button">
                    {{ $t("balanceIn.continue") }}
                </button>
                <button v-if="loader" type="button" class="button button-loader"></button>
            </div>
        </div>
    </modal>
</template>

<script>
import { mapGetters } from "vuex";
import { localizeValidation } from "@/mixins/localizeValidation";
import { declineNouns } from "@/mixins/declineNouns";
import { checkScroll } from "@/mixins/checkScroll";

export default {
    name: "BalanceIn",
    props: {
        i18n: Object,
    },
    mixins: [localizeValidation, declineNouns, checkScroll],
    data() {
        return {
            hasBugs: false,
            currentPackage: 1,
            wayIndex: 1,
            ways: [
                this.$t("balanceIn.bankCards"),
                this.$t("balanceIn.mobilePayment"),
                this.$t("balanceIn.qiwi"),
            ],
            pageLoader: true,
            loader: false,
            afterMordaLenta: false,
            body: null,
            phone: "",
        };
    },
    computed: {
        ...mapGetters({
            user: "user/fetchUser",
            packages: "balance/fetchPackages",
            balanceErrors: "balance/errors",
            replenishmentLink: "balance/fetchReplenishmentLink",
            //   payment: ''
        }),
    },
    watch: {
        $route(to, from) {
            if (to != from) {
                this.$modal.hide("balance-in");
            }
        },
    },
    methods: {
        beforeOpen() {
            this.getPackages();
            this.checkScroll();
            this.localizeValidation();
            if (this.user.phone) {
                this.phone = this.user.phone;
            }
        },
        beforeClose() {
            this.checkRemoveScroll();
        },
        getPackages() {
            this.$store
                .dispatch("balance/getPackages")
                .then(() => {
                    this.pageLoader = false;
                    this.currentPackage = this.packages[0].id;
                })
                .catch(() => {
                    this.pageLoader = false;
                });
        },
        send() {
            this.$validator.validateAll().then((valid) => {
                if (valid) {
                    this.loader = true;
                    let data = [this.currentPackage, this.wayIndex];
                    if (this.wayIndex == 2 || this.wayIndex == 3) {
                        let newPhone = this.phone.slice(1);
                        data.push(newPhone);
                    }
                    this.$store
                        .dispatch("balance/replenish", data)
                        .then(() => {
                            this.loader = false;
                            this.$modal.hide("balance-in");
                            window.location.href = this.replenishmentLink;
                        })
                        .catch(() => {
                            this.loader = false;
                        });
                }
            });
        },
        close() {
            this.$modal.hide("balance-in");
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/layout/_balance";

.error-modal {
    transition: box-shadow 1s;

    &.has-bugs {
        box-shadow: 0 24px 80px -2px rgba(255, 0, 0, 0.4) !important;
    }
}
</style>
